var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 27,
    viewBox: "0 0 35 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5002 6.11932L21.915 3.53409H12.8862L10.3009 6.11932H2.78409V24.2159H32.2159V6.11932H24.5002ZM33 3.33523C34.1046 3.33523 35 4.23066 35 5.33523V25C35 26.1046 34.1046 27 33 27H2C0.89543 27 0 26.1046 0 25V5.33523C0 4.23066 0.895431 3.33523 2 3.33523H9.14773L11.733 0.75H23.0682L25.6534 3.33523H33ZM17.6984 20.2386C20.5539 20.2386 22.8688 17.9237 22.8688 15.0681C22.8688 12.2125 20.5539 9.89765 17.6984 9.89765C14.8428 9.89765 12.5279 12.2125 12.5279 15.0681C12.5279 17.9237 14.8428 20.2386 17.6984 20.2386ZM17.6984 23.0226C22.0916 23.0226 25.6529 19.4613 25.6529 15.0681C25.6529 10.6749 22.0916 7.11356 17.6984 7.11356C13.3052 7.11356 9.74384 10.6749 9.74384 15.0681C9.74384 19.4613 13.3052 23.0226 17.6984 23.0226ZM6.16493 10.6934C6.93374 10.6934 7.55698 10.0702 7.55698 9.30138C7.55698 8.53257 6.93374 7.90933 6.16493 7.90933C5.39613 7.90933 4.77289 8.53257 4.77289 9.30138C4.77289 10.0702 5.39613 10.6934 6.16493 10.6934Z",
    fill: "#011627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.0848e68d0b108e314f584952ca85521e.svg";
export { ForwardRef as ReactComponent };